import { Card, CardHeader, Typography, Button } from "@mui/material";
import React from "react";
import { useDispatch } from "react-redux";
import { IoIosAddCircleOutline } from "react-icons/io";
import { useSelector } from "react-redux";
import { setDialog } from "../../../../../app/slices/productsSlice";
import { MdOutlineDevices } from "react-icons/md";
import ProductsForm from "../../form";
import Permission from "../../../../../components/userPermission/userPermission";

const ProductHeader = () => {
  const _Product = useSelector((state) => state.product.product);
  const dispatch = useDispatch();

  return (
    <Card>
      <CardHeader
        title={
          <Typography variant="h4" component="div">
            الاجهزة
          </Typography>
        }
        avatar={<MdOutlineDevices size={20} />}
        action={
          <Permission permission="product_edit">
            <Button
              variant="contained"
              color="primary"
              size="medium"
              startIcon={<IoIosAddCircleOutline />}
              onClick={() => dispatch(setDialog())}
            >
              إضافة
            </Button>
          </Permission>
        }
      />
      {_Product.dialog ? <ProductsForm /> : null}
    </Card>
  );
};

export default ProductHeader;
